import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "./client";

export const GET_VENUES = gql`
  query getVenues($clientIds: [Int!]) {
    venues(clientIds: $clientIds) {
      id
      name
    }
  }
`;

export const useVenues = ({ clientIds }: { clientIds: number[] | null }) => {
  const { data, loading, networkStatus } = useQuery(GET_VENUES, {
    client: shiftStreamClient,
    variables: { clientIds },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: error => {
      throw error;
    }
  });

  const resolvedData = data;

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    venues: resolvedData?.venues || []
  };
};
